export enum PromoteJobPriceTypesEnums {
  LITE = '4.99€',
  PLUS = '9.99€',
  PRO = '14.99€',
  MONTHLY = '15.99€',
}
